module.exports = __webpack_public_path__ + "img/stock-m.29bb3bd0.png";